import New from "../index/New";

export default props => {
  return <div className="index">
    <New {...props} type={0}/>
  </div>;
};